import { PM_REACT_MESSAGING_STYLES } from "@/styles/pmReactStyles";

const STYLE_ID = "pmreact-messaging-styles";
const OVERLAY_ROOT_ID = "pmreact-messaging-overlay-root";

export const ensureMessagingDocumentStyles = (): void => {
  if (typeof document === "undefined") return;
  const existing = document.getElementById(STYLE_ID);
  if (existing) return;
  const styleEl = document.createElement("style");
  styleEl.id = STYLE_ID;
  styleEl.textContent = PM_REACT_MESSAGING_STYLES;
  document.head.appendChild(styleEl);
};

export const ensureMessagingOverlayRoot = (): HTMLElement => {
  if (typeof document === "undefined") {
    throw new Error("document is not available");
  }

  // Ensure styles exist even if the overlay root was created in a prior session/version.
  ensureMessagingDocumentStyles();

  const existing = document.getElementById(OVERLAY_ROOT_ID);
  if (existing && existing instanceof HTMLElement) {
    // Keep the overlay root on top of Ionic’s stacking contexts so Radix overlays/backdrops render.
    Object.assign(existing.style, {
      position: "fixed",
      top: "0",
      left: "0",
      width: "0",
      height: "0",
      pointerEvents: "auto",
      backgroundColor: "transparent",
      zIndex: "2147483000",
    } as Partial<CSSStyleDeclaration>);
    return existing;
  }

  const el = document.createElement("div");
  el.id = OVERLAY_ROOT_ID;
  el.className = "pm-react-root";
  Object.assign(el.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "0",
    height: "0",
    pointerEvents: "auto",
    backgroundColor: "transparent",
    zIndex: "2147483000",
  } as Partial<CSSStyleDeclaration>);
  document.body.appendChild(el);
  return el;
};
